<script>
import cloneDeep from 'lodash/cloneDeep'
import draggable from 'vuedraggable'
import { generateUniqueString } from '@utils'

const initData = () => {
  return {
    id: '',
    productId: '',
    title: '',
    state: 1,
    type: 'text',
    displayType: '',
    required: 1,
    params: {
      options: [],
    },
    showOtherAnswer: false,
  }
}
const otherAnswerData = {
  title: '其他',
  optionType: 'text',
}

function checkOtherAnswer(submitData) {
  if (submitData.params !== undefined) {
    const otherAnswerList = submitData.params.options.filter((option) => option.optionType === 'text')
    return otherAnswerList.length > 0
  }
  return false
}

export default {
  components: {
    draggable,
  },
  props: {
    itemIndex: {
      type: Number,
      default: 0,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: () => { },
    },
    group: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      radio: '1',
      submitData: Object.assign(
        initData(),
        {
          productId: this.$route.params.productId,
          displayType: this.group,
          showOtherAnswer: checkOtherAnswer(this.defaultValue),
          default: 0,
        },
        this.defaultValue
      ),
      drag: false,
      loading: false,
      previousType: this.defaultValue.type || 'text',
      cloneIsActive: false
    }
  },
  computed: {
    submitRules() {
      return {
        title: [
          {
            required: true,
            message: '請填寫問題標題',
          },
        ],
      }
    },
    showRemoveButton() {
      const minOptionNum = this.submitData.showOtherAnswer ? 2 : 1
      return this.submitData.params.options.length > minOptionNum
    },
  },
  watch: {
    defaultValue: 'updateSubmitData',
    "submitData.required": {
      handler(nvl, ovl) {
        this.onClickSave()
      }
    }
  },
  created() {
    this.originalData = cloneDeep(this.submitData)
  },
  mounted() {
    this.cloneIsActive = this.isActive
  },
  methods: {
    // /**
    //  * @description 問題形式
    //  */
    // typeSelect(type) {
    //   const typeList = {
    //     'checkbox': '複選',
    //     'text': '簡答',
    //     'radio': '單選'
    //   }
    //   return typeList[type]
    // },
    /**
     * @description 開啟關閉 card
     */
    openCloseCard() {
      this.cloneIsActive = !this.cloneIsActive
    },
    /**
     * @description 關閉card
     */
    closeCard() {
      this.cloneIsActive = false
    },
    onClickSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('save', {
            index: this.itemIndex,
            data: this.submitData,
          })
        }
      })
    },
    onClickButton(event) {
      if (event === 'cancel') this.submitData = cloneDeep(this.originalData)
      this.$emit(event, this.itemIndex, this.group)
    },
    updateSubmitData() {
      this.submitData = Object.assign(initData(), {
        showOtherAnswer: checkOtherAnswer(this.defaultValue),
        ...this.defaultValue,
      })
    },
    addOption() {
      const optionData = {
        title: '',
        optionType: 'default',
      }
      const options = this.submitData.params.options
      if (this.submitData.showOtherAnswer) {
        options.splice(options.length - 1, 0, optionData)
      } else options.push(optionData)
    },

    removeOption(index) {
      this.submitData.params.options.splice(index, 1)
    },
    updateOtherAnswerDisplay() {
      const otherAnswerOptionIndex = this.submitData.params.options.length - 1
      if (this.submitData.showOtherAnswer) this.removeOption(otherAnswerOptionIndex)
      else this.submitData.params.options.push(otherAnswerData)
      this.submitData.showOtherAnswer = !this.submitData.showOtherAnswer
    },
    checkPreviousTypeIsChoice() {
      return this.previousType === 'radio' || this.previousType === 'checkbox'
    },
    updatePreviousType(type) {
      this.previousType = type
    },
    clearOptions() {
      this.submitData.params.options = []
    },
    addDefaultOption() {
      this.submitData.params.options.length === 0 && this.addOption()
      this.submitData.showOtherAnswer = false
    },
    typeChanged(chosedType) {
      if (chosedType === 'text') {
        this.clearOptions()
      } else {
        if (this.checkPreviousTypeIsChoice()) return
        this.addDefaultOption()
      }
      this.updatePreviousType(chosedType)
    },
    async updateExtraField() {
      this.loading = true
      const response = await this.$store.dispatch('product/updateExtraField', this.submitData)
      this.loading = false
      response && this.$set(this.submitData, 'id', response.id)
    },
    generateUniqueString() {
      return generateUniqueString(15)
    },
  },
}
</script>

<template>
  <div>
   

    <div :class="$style.content">
      <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating">
        <!-- <el-row :gutter="20">
          <el-col :sm="12" :span="24">
            <el-form-item label="問題類型" prop="title" class="is-border is-padding is-round">
              <el-radio v-model="radio" label="1">初次預約才需填寫</el-radio>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :span="24">
            <el-form-item label="問題類型" prop="title" class="is-border is-padding is-round is-empty-label">
              <el-radio v-model="radio" label="2">每次預約需填寫</el-radio>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col :sm="18" :span="24">
            <el-form-item label="問題標題" prop="title">
              <el-input v-model="submitData.title" placeholder="請輸入問題標題" class="bg-white is-border"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="6" :span="24">
            <el-form-item label="回答形式" prop="type">
              <el-select v-model="submitData.type" @change="typeChanged" class="bg-white is-border">
                <el-option label="簡答" value="text"></el-option>
                <el-option label="單選" value="radio"></el-option>
                <el-option label="複選" value="checkbox"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div v-if="submitData.type !== 'text'">
          <draggable v-model="submitData.params.options" animation="200" handle=".handle" @start="drag = true"
            @end="drag = false">
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <div v-for="(option, index) in submitData.params.options" :key="`${group}.${itemIndex}.${index}`">
                <el-row v-if="option.optionType !== 'text'" :gutter="10">
                  <el-col :span="1">
                    <el-button type="text" :class="[$style.drag, 'handle']">
                      <BaseIcon icon-style="fas" name="fa-grip-dots-vertical" />
                    </el-button>
                  </el-col>
                  <el-col :span="22">
                    <el-form-item :prop="'params.options.' + index + '.title'"
                      :rules="{ required: true, message: '請填寫選項名稱' }" :label="`選項 ${index + 1}`">
                      <el-input v-model="option.title" placeholder="請填寫選項名稱" class="bg-white is-border"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <el-button v-show="showRemoveButton" type="text" :class="$style['font-md']"
                      @click="removeOption(index)">
                      <BaseIcon name="times" />
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </transition-group>
          </draggable>

          <el-row v-show="submitData.showOtherAnswer" :gutter="10">
            <el-col :span="22" :offset="1">
              <el-form-item label="  ">
                <el-input placeholder="其他" :disabled="true"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-button type="text" :class="$style['font-md']" @click="updateOtherAnswerDisplay">
                <BaseIcon name="times" />
              </el-button>
            </el-col>
          </el-row>
        </div>

        <div v-if="submitData.type !== 'text'">
          <el-row>
            <el-col :offset="1">
              <el-form-item>
                <el-button class="is-round" type="primary" @click="addOption">
                  <BaseIcon name="plus" />
                  <span>新增選項</span>
                </el-button>
                <span v-show="!submitData.showOtherAnswer">
                  <span style="margin: 0 10px;"> 或 </span>
                  <el-button class="is-round" @click="updateOtherAnswerDisplay">
                    <span>新增「其他」輸入框</span>
                  </el-button>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div :class="$style.footer">
          <el-row :gutter="20">
            <el-col :sm="12" :span="24">
              <el-button class="is-round is-full" @click="onClickButton('remove')">刪除</el-button>
            </el-col>
            <el-col :sm="12" :span="24">
              <el-button class="is-round is-full" :loading="loading" type="primary" @click="onClickSave">
                <BaseIcon name="check" />
                <span>儲存問題</span>
              </el-button>
            </el-col>
          </el-row>
          <!-- <el-button class="is-round" @click="onClickButton('cancel')">取消</el-button>
          <el-button class="is-round" :loading="loading" type="primary" @click="onClickSave">
            <BaseIcon name="check" />
            <span>儲存問題</span>
          </el-button> -->
        </div>
      </el-form>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid $color-border-lighter;
  padding: 7px 20px;
  background-color: $color-line;
  border-top-left-radius: $border-radius;
  border-top-right-radius: $border-radius;

  h4 {
    display: inline-block;
    flex-shrink: 0;
  }

  &__title {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
  }

  &__qTitle {
    padding-left: 20px;
    // width:360px;
  }

  &__angleButton {
    // margin-left: 10px;
    // margin-right: 13px;
    position: absolute;
  }

  &__rightUser {
    min-width: 290px;
    margin-left: 10px;
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
    align-items: center;

    &__switch {
      margin-right: 30px;
      margin-left: 30px;
    }

    @include max-md {
      flex-direction: column;
      justify-content: center;
      align-items: center;

      >* {
        margin-bottom: 10px;
      }
    }
  }

  [class*='fa-']+span {
    margin-left: 1.5em;
  }
}

.content {
  padding: 4px 0;
}

.time-range {
  :global {
    .el-form-item__content {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }

  &__separator {
    margin: 0 5px;
  }
}

.read-only {
  opacity: 0.5;
  cursor: not-allowed;
}

.font-md {
  font-size: 18px;
  padding: 10px 0;
  width: 100%;
}

.drag {
  color: $color-primary;
  width: 100%;
  position: relative;
  top: 2px;
}

.vs-hide {
  visibility: hidden;
  pointer-events: none;
}

.radioGroup {
  border: 1px solid black;
  border-radius: $border-radius;
}

.elButtonRotate {
  transform: rotate(180deg);
}
</style>
